import c0 from './bridge/loading_controller';
import c1 from './bridge/play_button_controller';
import c2 from './feed_list_component/video_component_controller';
import c3 from './fixed_player_controller';
import c4 from './play_button_controller';
import c5 from './sidebar_controller';
import c6 from './subscriber_v2/add_button_controller';
import c7 from './subscriber_v2/add_to_queue_controller';
import c8 from './subscriber_v2/blocks/episodes/media_progress_controller';
import c9 from './subscriber_v2/blocks/episodes/season_chips_controller';
import c10 from './subscriber_v2/blocks/episodes/season_hero_resume_controller';
import c11 from './subscriber_v2/blocks/layout/tab_bar_component_controller';
import c12 from './subscriber_v2/blocks/live_streams/banner_component_controller';
import c13 from './subscriber_v2/blocks/live_streams/chat_tip_controller';
import c14 from './subscriber_v2/blocks/live_streams/editorial_info_panel_component_controller';
import c15 from './subscriber_v2/blocks/live_streams/pinned_tips_controller';
import c16 from './subscriber_v2/blocks/newsletters/choices_controller';
import c17 from './subscriber_v2/blocks/newsletters/resend_feedback_controller';
import c18 from './subscriber_v2/bridge/notification_controller';
import c19 from './subscriber_v2/button_controller';
import c20 from './subscriber_v2/chat_panel_controller';
import c21 from './subscriber_v2/connect_link_controller';
import c22 from './subscriber_v2/live_poll_controller';
import c23 from './subscriber_v2/notification_controller';
import c24 from './subscriber_v2/poll_interaction_controller';
import c25 from './subscriber_v2/queue_button_controller';
import c26 from './subscriber_v2/referral_source_controller';
import c27 from './subscriber_v2/shareable_link_controller';
import c28 from './subscriber_v2/thumbnail_controller';
import c29 from './subscriber_v2/vote_controller';
export const definitions = [
	{identifier: 'bridge--loading', controllerConstructor: c0},
	{identifier: 'bridge--play-button', controllerConstructor: c1},
	{identifier: 'feed-list-component--video-component', controllerConstructor: c2},
	{identifier: 'fixed-player', controllerConstructor: c3},
	{identifier: 'play-button', controllerConstructor: c4},
	{identifier: 'sidebar', controllerConstructor: c5},
	{identifier: 'subscriber-v2--add-button', controllerConstructor: c6},
	{identifier: 'subscriber-v2--add-to-queue', controllerConstructor: c7},
	{identifier: 'subscriber-v2--blocks--episodes--media-progress', controllerConstructor: c8},
	{identifier: 'subscriber-v2--blocks--episodes--season-chips', controllerConstructor: c9},
	{identifier: 'subscriber-v2--blocks--episodes--season-hero-resume', controllerConstructor: c10},
	{identifier: 'subscriber-v2--blocks--layout--tab-bar-component', controllerConstructor: c11},
	{identifier: 'subscriber-v2--blocks--live-streams--banner-component', controllerConstructor: c12},
	{identifier: 'subscriber-v2--blocks--live-streams--chat-tip', controllerConstructor: c13},
	{identifier: 'subscriber-v2--blocks--live-streams--editorial-info-panel-component', controllerConstructor: c14},
	{identifier: 'subscriber-v2--blocks--live-streams--pinned-tips', controllerConstructor: c15},
	{identifier: 'subscriber-v2--blocks--newsletters--choices', controllerConstructor: c16},
	{identifier: 'subscriber-v2--blocks--newsletters--resend-feedback', controllerConstructor: c17},
	{identifier: 'subscriber-v2--bridge--notification', controllerConstructor: c18},
	{identifier: 'subscriber-v2--button', controllerConstructor: c19},
	{identifier: 'subscriber-v2--chat-panel', controllerConstructor: c20},
	{identifier: 'subscriber-v2--connect-link', controllerConstructor: c21},
	{identifier: 'subscriber-v2--live-poll', controllerConstructor: c22},
	{identifier: 'subscriber-v2--notification', controllerConstructor: c23},
	{identifier: 'subscriber-v2--poll-interaction', controllerConstructor: c24},
	{identifier: 'subscriber-v2--queue-button', controllerConstructor: c25},
	{identifier: 'subscriber-v2--referral-source', controllerConstructor: c26},
	{identifier: 'subscriber-v2--shareable-link', controllerConstructor: c27},
	{identifier: 'subscriber-v2--thumbnail', controllerConstructor: c28},
	{identifier: 'subscriber-v2--vote', controllerConstructor: c29},
];
